/**
 * 处理socket消息发送
 * 
 */
import {getLoginId,dbType2SocketType,varToReplace} from '../functions/Common.js'
import {webSaveChatRecord} from '../network/web/chat-record.js'
import {webSaveClusterRecord} from '../network/web/cluster-chat-record.js'
import {handleMsg} from '../util/msgUtil.js'

/**
 * 主动发送socket消息，先保存到web服务器，然后渲染本地数据库，渲染视图，最后socket推送
 * @param {Object} chatUser 聊天对象
 * @param {Object} content 消息内容
 * @param {Object} type 消息的类型
 * @param {Object} vthis vue对象
 * @param {Object} aiteList 艾特列表
 * @param {boolean} msgToUp 消息是否置顶显示
 */
export function sendMsg(chatUser,content,type,vthis,is_send,aiteList,msgToUp,callback){
	if(chatUser === undefined || chatUser.type === undefined){
		return
	}
	if(is_send === undefined || is_send === ''){
		is_send = 2
	}
	if(msgToUp === undefined || msgToUp === ''){
		msgToUp = 1
	}else{
		msgToUp = msgToUp === true ? 1 : 0
	}
	let otherParam = {
		is_send: is_send,
		msgToUp: msgToUp
	}
	content = varToReplace(content,chatUser)
	// 普通消息
	if(chatUser.type == 1){
		webSaveChatRecord(chatUser.custom_wx_id,chatUser.fans_wx_id,content,type,otherParam,(data)=>{
			  if(data){
				  let bean = {
					  content: content,
					  friendId: chatUser.fans_id,
					  fromId: chatUser.custom_wx_id,
					  msgType: 1,
					  recentlyId: data.recently_id,
					  recodeId: data.recode_id,
					  time: (new Date()).getTime(),
					  toId: chatUser.fans_wx_id,
					  is_me:1,
					  is_send: is_send,
					  type: type,
					  msgToUp:msgToUp
				  }
				  // 渲染消息
				  handleMsg(bean,vthis)
				  // 推送消息
				  switch(type){
					  case 'program':
						sendProgramMsg(content,'program2',chatUser,data)
						break
					case 'file':
						sendNormalMsg(content,type,chatUser,data,true)
						break
					default:
						sendNormalMsg(content,type,chatUser,data)
				  }
				  if(callback !== undefined){
					callback(true)
				  }
			  }else{
				  if(callback !== undefined){
					  callback(false)
				  }
			  }
		})
	}
	// 群消息
	else if(chatUser.type == 2){
		webSaveClusterRecord(chatUser,content,type,otherParam,data=>{
			if(data){
			  let bean = {
				  content: content,
				  friendId: chatUser.fans_id,
				  clusterName: chatUser.fans_wx_name,
				  clusterImg: chatUser.fans_wx_photo,
				  fromId: chatUser.fans_wx_id,
				  mOpenId: chatUser.custom_wx_id,
				  mPhoto:chatUser.custom_wx_photo,
				  mWxName: chatUser.custom_wx_name,
				  msgType: 2,
				  recentlyId: data.recently_id,
				  recodeId: data.record_id,
				  time: (new Date()).getTime(),
				  toId: chatUser.custom_wx_id,
				  type: type,
				  is_me:1,
				  is_send: is_send
			  }
			  // 渲染消息
			  handleMsg(bean,vthis)
			  // 推送消息
			  switch(type){
				  case 'program':
					sendProgramClusterMsg(content,'program2',chatUser,data)
					break
				case 'file':
					sendNormalClusterMsg(content,type,chatUser,data,true)
					break
				default:
					sendNormalClusterMsg(content,type,chatUser,data,false,aiteList)
			  }
			  if(callback !== undefined){
			  		callback(true)
			  }
			}else{
				  if(callback !== undefined){
					  callback(false)
				  }
			  }
		})
	}
	
}

/**
 * 发送图片消息
 * @param {Object} content
 * @param {Object} type
 * @param {Object} chatUser
 * @param {Object} data
 * @param {Object} toObjContent 是否JOSN格式化content
 */
export function sendNormalMsg(content,type,chatUser,data,toObjContent){
	if(toObjContent !== undefined && toObjContent === true){
		try{
			content = JSON.parse(content)
		}catch(e){
			//TODO handle the exception
		}
	}
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'message',
		  bean:{
			  content: content,
			  fromId: chatUser.custom_wx_id,
			  msgType: 1,
			  phoneId: chatUser.phone_id,
			  recodeId: data.recode_id,
			  toId: chatUser.fans_wx_id,
			  type: dbType2SocketType(type)
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 发送小程序消息
 * @param {Object} content
 * @param {Object} type
 * @param {Object} chatUser
 * @param {Object} data
 */
export function sendProgramMsg(content,type,chatUser,data){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  appletContent: JSON.parse(content),
			  fromId: chatUser.custom_wx_id,
			  msgType: 1,
			  phoneId: chatUser.phone_id,
			  recodeId: data.recode_id,
			  toId: chatUser.fans_wx_id,
			  type: dbType2SocketType(type)
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 发送普通消息-群消息
 * @param {Object} content
 * @param {Object} type
 * @param {Object} chatUser
 * @param {Object} data
 */
export function sendNormalClusterMsg(content,type,chatUser,data,toObjContent,aiteList){
	if(toObjContent !== undefined && toObjContent === true){
		try{
			content = JSON.parse(content)
		}catch(e){
			//TODO handle the exception
		}
	}
	if(aiteList === undefined || aiteList === '' || (aiteList instanceof Array) === false){
		aiteList = []
	}
	// 修改aitelist里面的值，根据content
	let aiteListTemp = []
	if(aiteList.length > 0){
		for (let i = 0; i < aiteList.length; i++) {
			if(content.indexOf(aiteList[i].f_wname) !== -1){
				aiteListTemp.push(aiteList[i])
			}
		}
	}
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'message',
		  bean:{
			  content: content,
			  fromId: chatUser.custom_wx_id,
			  msgType: 2,
			  phoneId: chatUser.phone_id,
			  recodeId: data.record_id,
			  toId: chatUser.fans_wx_id,
			  type: dbType2SocketType(type),
			  aiteList: aiteListTemp
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 发送小程序消息-群消息
 * @param {Object} content
 * @param {Object} type
 * @param {Object} chatUser
 * @param {Object} data
 */
export function sendProgramClusterMsg(content,type,chatUser,data){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  appletContent: JSON.parse(content),
			  fromId: chatUser.custom_wx_id,
			  msgType: 2,
			  phoneId: chatUser.phone_id,
			  recodeId: data.record_id,
			  toId: chatUser.fans_wx_id,
			  type: dbType2SocketType(type)
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}